// @flow
import './default-bundle';

import ForeignShippingCountriesList from '@components/ForeignShippingCountriesList';
import SideMenuRouter from '@src/SideMenuRouter';

ReactOnRails.register({
  SideMenuRouter,
  ForeignShippingCountriesList
});
